import { useEffect, useState } from "react";

import { useSupabaseSession } from "~/context/SupabaseSessionContext";
import { useUserDetails } from "~/hooks/queries/use-user-details";
import { loginDismissalKey } from "~/lib/baa-nudge-session";

// AIDEV-NOTE: "Not now" for the BAA and DPA banners: hidden for the current login only
// (sessionStorage, keyed by profile + last_sign_in_at). Starts dismissed until the key
// resolves so the banner never flashes. `suffix` separates the DPA banner from the BAA
// nudge, whose unsuffixed key is shared with the eligibility dialog.
export function useLoginDismissal(suffix?: string) {
    const { data: userDetails } = useUserDetails();
    const { session } = useSupabaseSession();
    const [dismissed, setDismissed] = useState(true);

    const storageKey = loginDismissalKey(
        userDetails?.profile?.id,
        session?.user.last_sign_in_at,
        suffix,
    );

    useEffect(() => {
        if (!storageKey) {
            setDismissed(true);
            return;
        }
        // sessionStorage can throw (privacy modes, blocked storage): show the banner.
        try {
            setDismissed(window.sessionStorage.getItem(storageKey) === "true");
        } catch {
            setDismissed(false);
        }
    }, [storageKey]);

    const dismiss = () => {
        setDismissed(true);
        if (!storageKey) return;
        try {
            window.sessionStorage.setItem(storageKey, "true");
        } catch {
            // In-memory dismissal still holds for this page view.
        }
    };

    return { dismissed, dismiss };
}
